export const DashboardIcon = ({ fill = "none" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 19 16"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.048 9.564H12.165a2 2 0 0 0-2 2v2.714a2 2 0 0 0 2 2h2.883a2 2 0 0 0 2-2v-2.714a2 2 0 0 0-2-2Zm-8.007 0H4.158a2 2 0 0 0-2 2v2.714a2 2 0 0 0 2 2h2.883a2 2 0 0 0 2-2v-2.714a2 2 0 0 0-2-2Zm0-7.615H4.158a2 2 0 0 0-2 2v2.744a2 2 0 0 0 2 2h2.883a2 2 0 0 0 2-2V3.948a2 2 0 0 0-2-2Zm8.007 0H12.165a2 2 0 0 0-2 2v2.744a2 2 0 0 0 2 2h2.883a2 2 0 0 0 2-2V3.948a2 2 0 0 0-2-2Z"
      stroke="currentColor"
      strok="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IncentiveClaimIcon = ({ fill = "none" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 48 48"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="6"
      y="6"
      width="36"
      height="36"
      rx="3"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M6 14H40M30 22H42M30 30H42M23 22H24M23 30H24M14 6V42"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const DraftIcon = ({ fill = "currentColor" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 32 32"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="8" y="6" width="12" height="2" />
    <rect x="8" y="10" width="12" height="2" />
    <rect x="8" y="14" width="6" height="2" />
    <rect x="8" y="24" width="4" height="2" />
    <path d="M29.7 19.3l-3-3a1 1 0 0 0-1.4 0L16 25.6V30h4.4l9.3-9.3a1 1 0 0 0 0-1.4zM19.6 28H18v-1.6l5-5L24.6 23zm6.4-6.4L24.4 20 26 18.4 27.6 20z" />
    <path d="M12 30H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10h-2V4H6v24h6z" />
  </svg>
);

export const AppliedIcon = ({ fill = "none" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 48 48"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="6"
      y="4"
      width="36"
      height="40"
      rx="3"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M14 14H34M14 22H34M14 30H24M30 36L36 42L44 30"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const ApprovalIcon = ({ fill = "none" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 48 48"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="24" r="18" stroke="currentColor" strokeWidth="2" />
    <path
      d="M16 24L22 30L34 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const SettingsIcon = ({ fill = "none" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 3H13A1 1 0 0 1 14 4V4.57A1 1 0 0 0 15.84 5.33L16.24 4.93A1 1 0 0 1 17.66 4.93L19.07 6.34A1 1 0 0 1 19.07 7.76L18.67 8.16A1 1 0 0 0 19.43 10H20A1 1 0 0 1 21 11V13A1 1 0 0 1 20 14H19.43A1 1 0 0 0 18.67 15.84L19.07 16.24A1 1 0 0 1 19.07 17.66L17.66 19.07A1 1 0 0 1 16.24 19.07L15.84 18.67A1 1 0 0 0 14 19.43V20A1 1 0 0 1 13 21H11A1 1 0 0 1 10 20V19.43A1 1 0 0 0 8.16 18.67L7.76 19.07A1 1 0 0 1 6.34 19.07L4.93 17.66A1 1 0 0 1 4.93 16.24L5.33 15.84A1 1 0 0 0 4.57 14H4A1 1 0 0 1 3 13V11A1 1 0 0 1 4 10H4.57A1 1 0 0 0 5.33 8.16L4.93 7.76A1 1 0 0 1 4.93 6.34L6.34 4.93A1 1 0 0 1 7.76 4.93L8.16 5.33A1 1 0 0 0 10 4.57V4A1 1 0 0 1 11 3Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <circle cx="12" cy="12" r="2" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

export const FCIcon = ({ fill = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 640"
    width="20"
    height="20"
    fill={fill}
  >
    <path d="M32 160C32 124.7 60.7 96 96 96L544 96C579.3 96 608 124.7 608 160L32 160zM32 208L608 208L608 480C608 515.3 579.3 544 544 544L96 544C60.7 544 32 515.3 32 480L32 208zM279.3 480C299.5 480 314.6 460.6 301.7 445C287 427.3 264.8 416 240 416L176 416C151.2 416 129 427.3 114.3 445C101.4 460.6 116.5 480 136.7 480L279.2 480zM208 376C238.9 376 264 350.9 264 320C264 289.1 238.9 264 208 264C177.1 264 152 289.1 152 320C152 350.9 177.1 376 208 376zM392 272C378.7 272 368 282.7 368 296C368 309.3 378.7 320 392 320L504 320C517.3 320 528 309.3 528 296C528 282.7 517.3 272 504 272L392 272zM392 368C378.7 368 368 378.7 368 392C368 405.3 378.7 416 392 416L504 416C517.3 416 528 405.3 528 392C528 378.7 517.3 368 504 368L392 368z" />
  </svg>
);

export const IncentiveClaimDashboardIcon = ({ fill = "currentColor" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 1024 1024"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M511.98 36.13C230.01 36.13.64 265.54.64 547.5c0 177.15 89.68 339.19 239.9 433.41 14.94 9.47 34.69 4.88 44.1-10.1s4.88-34.72-10.1-44.1c-54.1-33.95-99.04-78.05-133.42-128.88l33.55-19.38c15.31-8.85 20.56-28.4 11.71-43.71-8.88-15.34-28.46-20.56-43.71-11.71l-33.6 19.39c-24.4-50.51-39.3-105.79-43.28-163.42h35.62c17.68 0 32-14.32 32-32s-14.32-32-32-32H65.95c4.24-58.69 19.78-114.3 44.56-164.6l32.16 18.56a31.75 31.75 0 0 0 15.97 4.29c11.06 0 21.81-5.74 27.75-16 8.85-15.31 3.6-34.88-11.71-43.71l-31.84-18.37c32.11-46.83 72.86-87.3 119.98-119.02l18.02 31.2c5.94 10.29 16.69 16 27.75 16 5.44 0 10.94-1.38 15.97-4.29 15.31-8.85 20.56-28.4 11.71-43.71l-17.95-31.07c49.33-23.79 103.68-38.66 160.98-42.82v39.87c0 17.68 14.32 32 32 32s32-14.32 32-32v-40c58.59 4.08 114.13 19.39 164.38 43.95l-17.36 30.05c-8.85 15.31-3.6 34.88 11.71 43.71a31.75 31.75 0 0 0 15.97 4.29c11.06 0 21.81-5.71 27.75-16l17.28-29.94a451.19 451.19 0 0 1 118.88 118.82l-29.97 17.31c-15.31 8.85-20.56 28.4-11.71 43.71 5.94 10.29 16.69 16 27.75 16 5.44 0 10.94-1.38 15.97-4.29l30.13-17.39c32.73 49.93 48.09 105.49 52.19 164.11H922.96c-17.68 0-32 14.32-32 32s14.32 32 32 32h35.12c-4.05 56.88-18.59 111.44-42.5 161.31l-31.68-18.29c-15.28-8.85-34.91-3.57-43.71 11.71-8.85 15.31-3.6 34.88 11.71 43.71l31.78 18.35c-35.1 52.24-81.44 97.39-137.36 131.82-15.06 9.28-19.71 29.01-10.47 44.03 6.07 9.81 16.53 15.22 27.28 15.22a31.9 31.9 0 0 0 16.75-4.75c152.46-93.9 243.47-256.78 243.47-435.63 0-281.95-229.41-511.36-511.38-511.36Zm236.13 411.6c15.3-8.85 20.54-28.4 11.71-43.71-8.83-15.3-28.42-20.54-43.71-11.7L542.29 492.67c-9.28-5.25-19.86-8.5-31.28-8.5-35.28 0-63.84 28.59-63.84 63.81 0 35.25 28.58 63.84 63.84 63.84 35.28 0 63.84-28.59 63.84-63.84 0-.06-.01-.14-.01-.21z" />
  </svg>
);

export const TransactionIcon = ({ fill = "currentColor" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 1024 1024"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 832c-212.1 0-384-171.9-384-384S299.9 128 512 128s384 171.9 384 384-171.9 384-384 384z" />
    <path d="M320 368c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32s-14.3 32-32 32H384v48c0 28.4-34.5 42.7-54.6 22.6l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c20-20 54.6-5.9 54.6 22.6v48zm384 288c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32s14.3-32 32-32h224v-48c0-28.4 34.5-42.7 54.6-22.6l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-20 20-54.6 5.9-54.6-22.6v-48z" />
  </svg>
);

export const AdminDashboardIcon = ({ fill = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 640"
    width="20"
    height="20"
    fill={fill}
  >
    <path d="M480 160L480 288L352 288L352 160L480 160zM480 352L480 480L352 480L352 352L480 352zM288 288L160 288L160 160L288 160L288 288zM160 352L288 352L288 480L160 480L160 352zM160 96C124.7 96 96 124.7 96 160L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 160C544 124.7 515.3 96 480 96L160 96z" />
  </svg>
);

export const RegisterUserIcon = ({ fill = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 640"
    width="20"
    height="20"
    fill={fill}
  >
    <path d="M136 192C136 125.7 189.7 72 256 72C322.3 72 376 125.7 376 192C376 258.3 322.3 312 256 312C189.7 312 136 258.3 136 192zM48 546.3C48 447.8 127.8 368 226.3 368L285.7 368C384.2 368 464 447.8 464 546.3C464 562.7 450.7 576 434.3 576L77.7 576C61.3 576 48 562.7 48 546.3zM544 160C557.3 160 568 170.7 568 184L568 232L616 232C629.3 232 640 242.7 640 256C640 269.3 629.3 280 616 280L568 280L568 328C568 341.3 557.3 352 544 352C530.7 352 520 341.3 520 328L520 280L472 280C458.7 280 448 269.3 448 256C448 242.7 458.7 232 472 232L520 232L520 184C520 170.7 530.7 160 544 160z" />
  </svg>
);

export const UserClockIcon = ({ fill = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 640"
    width="20"
    height="20"
    fill={fill}
  >
    <path d="M256 72C322.3 72 376 125.7 376 192C376 258.3 322.3 312 256 312C189.7 312 136 258.3 136 192C136 125.7 189.7 72 256 72zM226.3 368L285.7 368C289.6 368 293.6 368.1 297.5 368.4C281.3 396.6 272 429.2 272 464C272 505.8 285.4 544.5 308 576L77.7 576C61.3 576 48 562.7 48 546.3C48 447.8 127.8 368 226.3 368zM320 464C320 384.5 384.5 320 464 320C543.5 320 608 384.5 608 464C608 543.5 543.5 608 464 608C384.5 608 320 543.5 320 464zM464 384C455.2 384 448 391.2 448 400L448 464C448 472.8 455.2 480 464 480L512 480C520.8 480 528 472.8 528 464C528 455.2 520.8 448 512 448L480 448L480 400C480 391.2 472.8 384 464 384z" />
  </svg>
);

export const AllApplicationsIcon = ({ fill = "none" }) => (
  <svg
    width="24"
    height="22"
    viewBox="0 0 24 22"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1007_2898)">
      <path
        d="M14.0456 7.24219H4.88116C4.70755 7.24219 4.54105 7.18073 4.41829 7.07133C4.29553 6.96194 4.22656 6.81356 4.22656 6.65885V4.32552C4.22656 4.17081 4.29553 4.02244 4.41829 3.91304C4.54105 3.80365 4.70755 3.74219 4.88116 3.74219H14.0456C14.2192 3.74219 14.3857 3.80365 14.5084 3.91304C14.6312 4.02244 14.7002 4.17081 14.7002 4.32552V6.65885C14.7002 6.81356 14.6312 6.96194 14.5084 7.07133C14.3857 7.18073 14.2192 7.24219 14.0456 7.24219ZM5.53576 6.07552H13.391V4.87385H5.53576V6.07552Z"
        fill="#1137AA"
      />
      <path
        d="M14.0456 8.45508H4.88116C4.70755 8.45508 4.54105 8.51654 4.41829 8.62593C4.29553 8.73533 4.22656 8.8837 4.22656 9.03841V11.3251C4.22656 11.4798 4.29553 11.6282 4.41829 11.7376C4.54105 11.847 4.70755 11.9084 4.88116 11.9084H12.3174L14.7002 9.75008V9.03841C14.7002 8.8837 14.6312 8.73533 14.5084 8.62593C14.3857 8.51654 14.2192 8.45508 14.0456 8.45508ZM13.391 10.7417H5.53576V9.57508H13.391V10.7417Z"
        fill="#1137AA"
      />
      <path
        d="M7.5381 18.6224V18.5874L7.74757 17.7765H2.91662V2.57487H16.0086V8.55404L17.3178 7.45154V1.99154C17.3178 1.83683 17.2489 1.68845 17.1261 1.57906C17.0033 1.46966 16.8368 1.4082 16.6632 1.4082H2.26202C2.08841 1.4082 1.92191 1.46966 1.79915 1.57906C1.67639 1.68845 1.60742 1.83683 1.60742 1.99154V18.3249C1.60742 18.4796 1.67639 18.628 1.79915 18.7373C1.92191 18.8467 2.08841 18.9082 2.26202 18.9082H7.49882C7.50413 18.8122 7.51725 18.7167 7.5381 18.6224Z"
        fill="#1137AA"
      />
      <path
        d="M14.7 11.4238L14.1895 11.8847C14.3161 11.8614 14.4322 11.8052 14.5231 11.7232C14.614 11.6412 14.6755 11.537 14.7 11.4238Z"
        fill="#1137AA"
      />
      <path
        d="M4.22656 15.9578C4.22656 16.1125 4.29553 16.2609 4.41829 16.3703C4.54105 16.4797 4.70755 16.5412 4.88116 16.5412H8.04943L8.24581 15.7828L8.33091 15.462V15.4328H5.53576V14.2428H9.68593L10.9951 13.0762H4.88116C4.70755 13.0762 4.54105 13.1376 4.41829 13.247C4.29553 13.3564 4.22656 13.5048 4.22656 13.6595V15.9578Z"
        fill="#1137AA"
      />
      <path
        d="M22.2211 9.96643L20.0151 8.0006C19.9172 7.91311 19.8009 7.8437 19.6728 7.79635C19.5448 7.74899 19.4075 7.72461 19.2689 7.72461C19.1302 7.72461 18.9929 7.74899 18.8649 7.79635C18.7368 7.8437 18.6205 7.91311 18.5226 8.0006L9.54805 16.0448L8.80835 18.8506C8.78066 18.9716 8.78004 19.0964 8.80652 19.2176C8.833 19.3389 8.88608 19.4543 8.96269 19.5573C9.03931 19.6602 9.13797 19.7487 9.25302 19.8176C9.36806 19.8865 9.49724 19.9346 9.63315 19.9589C9.70063 19.9648 9.76859 19.9648 9.83607 19.9589C9.91632 19.9701 9.99803 19.9701 10.0783 19.9589L13.2531 19.3348L22.2211 11.3256C22.3191 11.2389 22.3968 11.1357 22.4499 11.0221C22.5029 10.9084 22.5303 10.7866 22.5303 10.6635C22.5303 10.5404 22.5029 10.4186 22.4499 10.305C22.3968 10.1913 22.3191 10.0882 22.2211 10.0014V9.96643ZM12.5854 18.2731L10.1896 18.7456L10.7722 16.6281L17.5014 10.5673L19.3474 12.2123L12.5854 18.2731ZM20.0871 11.5531L18.2411 9.90809L19.282 8.99226L21.141 10.6489L20.0871 11.5531Z"
        fill="#1137AA"
      />
    </g>
    <defs>
      <clipPath id="clip0_1007_2898">
        <rect
          width="23.5656"
          height="21"
          fill="white"
          transform="translate(0.298828 0.242188)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const FileSignatureIcon = ({ fill = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 640"
    width="20"
    height="20"
    fill={fill}
  >
    <path d="M64.1 128C64.1 92.7 92.8 64 128.1 64L277.6 64C294.6 64 310.9 70.7 322.9 82.7L429.3 189.3C441.3 201.3 448 217.6 448 234.6L448 332.1L316 464.1L273.9 464.1L257.8 410.5C253.1 394.8 238.7 384.1 222.3 384.1C211 384.1 200.4 389.2 193.4 398L133.3 473C125 483.3 126.7 498.5 137 506.7C147.3 514.9 162.5 513.3 170.7 502.9L217.8 444.1L233 494.8C236 505 245.4 511.9 256 511.9L287.5 511.9C286.6 515 285.8 518.2 285.2 521.4L274.3 575.9L128.1 575.9C92.8 575.9 64.1 547.2 64.1 511.9L64.1 127.9zM272.1 122.5L272.1 216C272.1 229.3 282.8 240 296.1 240L389.6 240L272.1 122.5zM332.3 530.9C334.8 518.5 340.9 507.1 349.8 498.2L468.7 379.3L548.7 459.3L429.8 578.2C420.9 587.1 409.5 593.2 397.1 595.7L337.5 607.6C336.6 607.8 335.6 607.9 334.6 607.9C326.6 607.9 320 601.4 320 593.3C320 592.3 320.1 591.4 320.3 590.4L332.2 530.8zM600.1 407.9L571.3 436.7L491.3 356.7L520.1 327.9C542.2 305.8 578 305.8 600.1 327.9C622.2 350 622.2 385.8 600.1 407.9z" />
  </svg>
);

export const NewRecordIcon = ({ fill = "currentColor" }) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.33978 1.4707V13.7207ZM0.519531 7.5957H14.16Z" fill="#1138AA" />
    <path d="M7.33978 1.4707V13.7207ZM0.519531 7.5957H14.16Z" fill="#1137AA" />
    <path
      d="M7.33978 1.4707V13.7207M0.519531 7.5957H14.16"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CancelApplicationIcon = ({ fill = "currentColor" }) => (
  <svg
    width="19"
    height="17"
    viewBox="0 0 19 17"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.52865 9.06091L12.6913 11.9012C12.7822 11.9828 12.894 12.0266 13.0265 12.0324C13.159 12.0382 13.2772 11.9945 13.3811 11.9012C13.485 11.8078 13.537 11.7046 13.537 11.5914C13.537 11.4782 13.485 11.375 13.3811 11.2817L10.2185 8.44141L13.3811 5.60116C13.4721 5.51949 13.5208 5.41916 13.5273 5.30016C13.5338 5.18116 13.485 5.07499 13.3811 4.98166C13.2772 4.88832 13.1622 4.84166 13.0362 4.84166C12.9102 4.84166 12.7952 4.88832 12.6913 4.98166L9.52865 7.82191L6.36601 4.98166C6.27507 4.89999 6.16335 4.85624 6.03084 4.85041C5.89833 4.84457 5.78012 4.88832 5.67619 4.98166C5.57226 5.07499 5.5203 5.17824 5.5203 5.29141C5.5203 5.40457 5.57226 5.50782 5.67619 5.60116L8.83883 8.44141L5.67619 11.2817C5.58525 11.3633 5.53654 11.4639 5.53004 11.5835C5.52354 11.7019 5.57226 11.8078 5.67619 11.9012C5.78012 11.9945 5.89508 12.0412 6.0211 12.0412C6.14711 12.0412 6.26208 11.9945 6.36601 11.9012L9.52865 9.06091ZM9.53158 16.3164C8.31887 16.3164 7.17892 16.1099 6.11171 15.6969C5.0445 15.2833 4.11598 14.7222 3.32613 14.0134C2.53628 13.3047 1.91109 12.4717 1.45056 11.5144C0.99003 10.5572 0.759766 9.5337 0.759766 8.44403C0.759766 7.35436 0.99003 6.33061 1.45056 5.37278C1.91044 4.41436 2.53433 3.58049 3.32223 2.87116C4.11013 2.16182 5.03801 1.60036 6.10586 1.18678C7.17372 0.773198 8.31367 0.566406 9.52573 0.566406C10.7378 0.566406 11.8777 0.773198 12.9456 1.18678C14.0128 1.59978 14.9413 2.16036 15.7312 2.86853C16.521 3.5767 17.1462 4.40999 17.6067 5.36841C18.0673 6.32682 18.2975 7.35028 18.2975 8.43878C18.2975 9.52728 18.0676 10.551 17.6077 11.51C17.1478 12.469 16.523 13.3029 15.7331 14.0117C14.9433 14.7204 14.0157 15.2819 12.9505 15.696C11.8852 16.1102 10.7456 16.317 9.53158 16.3164ZM9.52865 15.4414C11.7046 15.4414 13.5477 14.7633 15.0579 13.407C16.5681 12.0508 17.3232 10.3956 17.3232 8.44141C17.3232 6.48724 16.5681 4.83203 15.0579 3.47578C13.5477 2.11953 11.7046 1.44141 9.52865 1.44141C7.35267 1.44141 5.50958 2.11953 3.99938 3.47578C2.48918 4.83203 1.73409 6.48724 1.73409 8.44141C1.73409 10.3956 2.48918 12.0508 3.99938 13.407C5.50958 14.7633 7.35267 15.4414 9.52865 15.4414Z"
      fill={fill}
    />
  </svg>
);

export const PendingApplicationIcon = ({ fill = "currentColor" }) => (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.7757 16.7861C12.6896 16.7861 11.7686 16.4466 11.0125 15.7676C10.2564 15.0874 9.87838 14.2603 9.87838 13.2861C9.87838 12.3119 10.2564 11.4851 11.0125 10.8055C11.7686 10.1259 12.6893 9.78609 13.7747 9.78609C14.8607 9.78609 15.7818 10.1259 16.5379 10.8055C17.2946 11.4845 17.6729 12.3113 17.6729 13.2861C17.6729 14.2608 17.2946 15.088 16.5379 15.7676C15.7811 16.4472 14.8604 16.7867 13.7757 16.7861ZM15.3882 15.2128L15.9201 14.7351L14.1498 13.1417V10.7617H13.4005V13.4278L15.3882 15.2128ZM0.734375 15.9111V1.91109H6.82583C6.91676 1.56926 7.1191 1.28197 7.43283 1.04922C7.74656 0.815885 8.11193 0.699219 8.52894 0.699219C8.95374 0.699219 9.32204 0.815885 9.63382 1.04922C9.9456 1.28139 10.147 1.56868 10.2379 1.91109H16.3235V8.59172C16.1559 8.51414 15.9974 8.44618 15.848 8.38784C15.6986 8.32951 15.5324 8.2773 15.3492 8.23122V2.78609H12.4262V4.73734H4.63166V2.78609H1.7087V15.0361H8.27757C8.32953 15.1994 8.39091 15.3514 8.46171 15.492C8.53316 15.632 8.6241 15.7717 8.73452 15.9111H0.734375ZM8.53186 2.98734C8.75596 2.98734 8.9427 2.91968 9.0921 2.78434C9.24149 2.64843 9.31619 2.47984 9.31619 2.27859C9.31619 2.07734 9.2402 1.90964 9.0882 1.77547C8.93621 1.6413 8.74881 1.57422 8.52602 1.57422C8.30322 1.57422 8.11648 1.64247 7.96578 1.77897C7.81509 1.91547 7.74039 2.08405 7.74169 2.28472C7.74299 2.48539 7.81866 2.6528 7.96871 2.78697C8.11875 2.92114 8.30647 2.98734 8.53186 2.98734Z"
      fill={fill}
    />
  </svg>
);

export const ApprovedApplicationIcon = ({ fill = "currentColor" }) => (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3187 14.7295L16.0857 12.283L15.4758 11.7344L13.3187 13.6445L12.3882 12.7914L11.7773 13.3444L13.3187 14.7295ZM2.98988 5.02048H13.1832V4.14548H2.98891L2.98988 5.02048ZM13.9315 16.7324C12.8461 16.7324 11.9254 16.3926 11.1693 15.713C10.4126 15.034 10.0342 14.2071 10.0342 13.2324C10.0342 12.2576 10.4126 11.4304 11.1693 10.7509C11.926 10.0713 12.8468 9.73178 13.9315 9.73236C15.0162 9.73294 15.9373 10.0724 16.6947 10.7509C17.4521 11.4293 17.8301 12.2564 17.8288 13.2324C17.8288 14.2065 17.4508 15.0334 16.6947 15.713C15.9373 16.3926 15.0162 16.7324 13.9315 16.7324ZM0.291016 15.5537V0.880859H15.8801V7.49586C15.7217 7.44336 15.5645 7.39844 15.4086 7.36111C15.252 7.32378 15.0845 7.29461 14.9058 7.27361V1.75586H1.26534V14.0496H7.44643C7.4906 14.2888 7.54776 14.5227 7.61791 14.7514C7.68871 14.98 7.78711 15.1982 7.91313 15.4059L7.88 15.4356L6.77415 14.7129L5.46271 15.5537L4.15127 14.7129L2.83984 15.5537L1.52743 14.7129L0.291016 15.5537ZM2.98988 11.6162H7.57796C7.61434 11.4558 7.65915 11.3056 7.71242 11.1656C7.76568 11.0256 7.82804 10.8842 7.89949 10.7412H2.98988V11.6162ZM2.98988 8.31836H10.1122C10.4304 8.09261 10.7715 7.90448 11.1352 7.75398C11.499 7.6029 11.8877 7.49936 12.3015 7.44336H2.98891L2.98988 8.31836Z"
      fill={fill}
    />
  </svg>
);

export const UserShieldIcon = ({ fill = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 640"
    width="20"
    height="20"
    fill={fill}
  >
    <path d="M256 312C322.3 312 376 258.3 376 192C376 125.7 322.3 72 256 72C189.7 72 136 125.7 136 192C136 258.3 189.7 312 256 312zM226.3 368C127.8 368 48 447.8 48 546.3C48 562.7 61.3 576 77.7 576L329.2 576C293 533.4 272 478.5 272 420.4L272 389.3C272 382 273 374.8 274.9 368L226.3 368zM477.3 552.5L464 558.8L464 370.7L560 402.7L560 422.3C560 478.1 527.8 528.8 477.3 552.6zM453.9 323.5L341.9 360.8C328.8 365.2 320 377.4 320 391.2L320 422.3C320 496.7 363 564.4 430.2 596L448.7 604.7C453.5 606.9 458.7 608.1 463.9 608.1C469.1 608.1 474.4 606.9 479.1 604.7L497.6 596C565 564.3 608 496.6 608 422.2L608 391.1C608 377.3 599.2 365.1 586.1 360.7L474.1 323.4C467.5 321.2 460.4 321.2 453.9 323.4z" />
  </svg>
);

export const AddUserIcon = ({ fill = "currentColor" }) => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.87915 7.10938C7.42611 7.10938 8.68017 5.99009 8.68017 4.60938C8.68017 3.22866 7.42611 2.10938 5.87915 2.10938C4.33219 2.10938 3.07812 3.22866 3.07812 4.60938C3.07812 5.99009 4.33219 7.10938 5.87915 7.10938Z"
      fill={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.67969 13.3594V12.7344C1.67969 11.7398 2.12235 10.786 2.91029 10.0827C3.69823 9.37946 4.76691 8.98438 5.88122 8.98438C6.99554 8.98438 8.06422 9.37946 8.85216 10.0827C9.6401 10.786 10.0828 11.7398 10.0828 12.7344V13.3594"
      fill={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.67969 13.3594V12.7344C1.67969 11.7398 2.12235 10.786 2.91029 10.0827C3.69823 9.37946 4.76691 8.98438 5.88122 8.98438C6.99554 8.98438 8.06422 9.37946 8.85216 10.0827C9.6401 10.786 10.0828 11.7398 10.0828 12.7344V13.3594"
      fill={fill}
      strokeOpacity="0.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.881 5.85938C13.6545 5.85938 14.2815 5.29973 14.2815 4.60938C14.2815 3.91902 13.6545 3.35938 12.881 3.35938C12.1075 3.35938 11.4805 3.91902 11.4805 4.60938C11.4805 5.29973 12.1075 5.85938 12.881 5.85938Z"
      fill={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.881 5.85938C13.6545 5.85938 14.2815 5.29973 14.2815 4.60938C14.2815 3.91902 13.6545 3.35938 12.881 3.35938C12.1075 3.35938 11.4805 3.91902 11.4805 4.60938C11.4805 5.29973 12.1075 5.85938 12.881 5.85938Z"
      fill={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.882 3.35938V2.73438M12.882 7.10938V6.48438M14.2825 4.60938H14.9828M10.7812 4.60938H11.4815M13.8624 3.73437L14.3526 3.29688M13.8624 5.48437L14.3526 5.92188M11.9017 3.73437L11.4115 3.29688M11.9017 5.48437L11.4115 5.92188"
      fill={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RolesIcon = ({ fill = "currentColor" }) => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.67993 7.10938C10.2269 7.10938 11.481 5.99009 11.481 4.60938C11.481 3.22866 10.2269 2.10938 8.67993 2.10938C7.13297 2.10938 5.87891 3.22866 5.87891 4.60938C5.87891 5.99009 7.13297 7.10938 8.67993 7.10938Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.12891 13.3587C4.5894 12.6447 5.2526 12.0517 6.05169 11.6393C6.85078 11.2269 7.75752 11.0098 8.68057 11.0098C9.60362 11.0098 10.5104 11.2269 11.3095 11.6393C12.1085 12.0517 12.7717 12.6447 13.2322 13.3587"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.1799 7.10938L13.5804 7.73438L14.981 7.10938V8.98438C14.981 9.64742 14.6858 10.2833 14.1606 10.7521C13.6353 11.221 12.9228 11.4844 12.1799 11.4844C11.4371 11.4844 10.7246 11.221 10.1993 10.7521C9.67401 10.2833 9.37891 9.64742 9.37891 8.98438V7.10938L10.7794 7.73438L12.1799 7.10938Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PermissionIcon = ({ fill = "currentColor" }) => (
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.59614 11.3344C6.59614 11.3344 12.1142 9.36438 12.1142 6.40938V2.96187L6.59614 1.48438L1.07812 2.96187V6.40938C1.07812 9.36438 6.59614 11.3344 6.59614 11.3344Z"
      fill={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.59614 11.3344C6.59614 11.3344 12.1142 9.36438 12.1142 6.40938V2.96187L6.59614 1.48438L1.07812 2.96187V6.40938C1.07812 9.36438 6.59614 11.3344 6.59614 11.3344Z"
      fill={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NotificationIcon = ({ fill = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 640"
    width="20"
    height="20"
    fill={fill}
  >
    <path d="M320 64C302.3 64 288 78.3 288 96L288 99.2C215 114 160 178.6 160 256L160 277.7C160 325.8 143.6 372.5 113.6 410.1L103.8 422.3C98.7 428.6 96 436.4 96 444.5C96 464.1 111.9 480 131.5 480L508.4 480C528 480 543.9 464.1 543.9 444.5C543.9 436.4 541.2 428.6 536.1 422.3L526.3 410.1C496.4 372.5 480 325.8 480 277.7L480 256C480 178.6 425 114 352 99.2L352 96C352 78.3 337.7 64 320 64zM258 528C265.1 555.6 290.2 576 320 576C349.8 576 374.9 555.6 382 528L258 528z" />
  </svg>
);

export const RepsortsIcon = ({ fill = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width="20"
    height="20"
    fill={fill}
  >
    <path d="M332.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8V172.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-288 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zM496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z" />
  </svg>
);

export const MobileIcon = ({ fill = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 640"
    width="20"
    height="20"
    fill={fill}
  >
    <path d="M144 128C144 92.7 172.7 64 208 64L432 64C467.3 64 496 92.7 496 128L496 512C496 547.3 467.3 576 432 576L208 576C172.7 576 144 547.3 144 512L144 128zM208 128L208 432L432 432L432 128L208 128zM320 536C337.7 536 352 521.7 352 504C352 486.3 337.7 472 320 472C302.3 472 288 486.3 288 504C288 521.7 302.3 536 320 536z" />
  </svg>
);
